import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "phoneWithBoxesConnected",
    iconColor: "white",
    text: "Automation via \nInfrastructure blueprints",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithScheme",
    iconColor: "white",
    text: "Gen AI search across \nMELT (metrics, events, \nlogs and traces) in real-\ntime",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "personWithLight",
    iconColor: "white",
    text: "Gen AI \nrecommendations for \nefficiency, performance \nand reliability",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "screenWithDollarSignAndGear",
    iconColor: "white",
    text: "Impactful KPI driven \ncausal analysis",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_DNA1_1 = {
  title: "DATA & AI OPERATIONS COMMAND CENTER",
  titleNumber: "1.",
  text: "Single-stop for provisioning, monitoring, measuring and optimizing data and AI \nestate in real-time powered by AI agents.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage(103),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(101),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA1/DNA1_intro_02.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  demoButtons: [
    {
      label: "DATA OPERATIONS WORKBENCH DEMO",
      onClick: () => {
        setPreviousPage(102);
        setCurrentPage(105);
      },
      endIcon: "play",
    },
  ],
};
